import React from 'react'
import { t } from 'ttag'
import { Link } from 'react-router-dom'

import { useTitleChange } from '../../util/hooks'

const ChoosingIndustry = () => {
  useTitleChange(t`Choosing an Industry`)

  return (
    <div
      className={`container ${dynamicValues.tenantId === 'nevada' ? '' : 'dual'}`}
      id="choosingindustry">
      <p className="instructions">
        {t`There are many ways to go about choosing a career. Generally, it is best to
            figure out what you would like to do and then choose a career pathway that leads to employment in that career.
            But, sometimes you hear about important industries in your community and you want to learn more about the
            careers they offer.`}
      </p>
      <p className="instructions">
        {t`Industries are groupings of businesses that make similar products or provide
            similar services.  Exploring career pathways by industries helps you understand employment opportunities in
            your region based upon businesses in your community.   We put together this module so that you can take a
            look at industries in a variety of ways.`}
      </p>

      <br />
      <h2>
        {t`For each item below, you can read the brief description of what you will be looking at to pick what
            industry you are interested in exploring.`}
      </h2>

      <div className="mainsection">
        <a className="box majorswage" href="/industry/choosing/wages"></a>
        <div className="text">
          <h3>{t`Highest Wages`}</h3>
          <p>
            {t`Choose this option to see a list of industries displayed by the average wage of the
                    occupations employed in that industry`}
          </p>
        </div>
        <div className="navlink">
          <Link to="/industry/choosing/wages">{t`Explore these Industries`}</Link>
        </div>
      </div>

      <div className="mainsection">
        <a className="box majorsgrowth" href="/industry/choosing/employment"></a>
        <div className="text">
          <h3>{t`Most Job Openings`}</h3>
          <p>
            {t`Choose this option to see a list of industries displayed by the total number of projected
                    openings in the occupations employed in that industry.`}
          </p>
        </div>
        <div className="navlink">
          <Link to="/industry/choosing/employment">{t`Explore these Industries`}</Link>
        </div>
      </div>

      {dynamicValues.tenantId === 'nevada' && (
        <div className="mainsection">
          <a className="box majorscompletions" href="/industry/choosing/indemand"></a>
          <div className="text">
            <h3>{t`In-Demand`}</h3>
            <p>
              {t`Choose this option to see industries identified as in-demand by the State of Nevada.
                    These industries represent a mix of existing businesses and emerging opportunities.`}
            </p>
          </div>
          <div className="navlink">
            <Link to="/industry/choosing/indemand">{t`Explore these Industries`}</Link>
          </div>
        </div>
      )}
    </div>
  )
}

export default ChoosingIndustry
